import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  toolbarInner: {
    padding: 0,
  },
});

class PayVerify extends Component {

  state = {
    orderId: window.state.orderId,
    checkPaymentN: 0,
  }

  checkPayment() {

    this.setState({ checkPaymentN: this.state.checkPaymentN + 1});

    console.log('Check payment #' + this.state.checkPaymentN + '...');

    const url = '/pay/verify/check'
    const values = {
      orderId: this.state.orderId,
    };

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })
      .then(status)
      .then(json)
      .then(({ status, redirectUrl }) => {
        if (status === 'ok') {
          clearTimeout(this.timerId);
          window.location.href = redirectUrl;
        } else {
          this.timerId = setTimeout(() => this.checkPayment(), 1000);
        }
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  componentDidMount() {
    this.checkPayment();
  }

  componentWillUnmount() {
    clearTimeout(this.timerId)
  }

  render() {
    const { classes } = this.props

    return (
      <div className={classes.pageTemplate}>
        <AppBar
          position="static"
          color="inherit"
          elevation={0}
          style={{ padding: '24px' }}
        >
          <Toolbar className={classes.toolbarInner}>
            <LogoData />
          </Toolbar>
          <div style={{
            display: 'flex',
            width: '100%',
            marginTop: 100,
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <div>
              <img src="/images/loaders/oval.svg" width="60" height="60" alt="Загрузка..." />
            </div>
            <h2>Ожидаем подтверждения операции со стороны банка</h2>
          </div>
        </AppBar>
      </div>
    )
  }
}

export default withStyles(styles)(PayVerify)
